import { render, staticRenderFns } from "./DeviceSettingsBodySectionField.vue?vue&type=template&id=7f20f84f&scoped=true"
import script from "./DeviceSettingsBodySectionField.vue?vue&type=script&lang=js"
export * from "./DeviceSettingsBodySectionField.vue?vue&type=script&lang=js"
import style0 from "./DeviceSettingsBodySectionField.vue?vue&type=style&index=0&id=7f20f84f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f20f84f",
  null
  
)

export default component.exports